export default "__VITE_ASSET__DC0GNLRR__"